import { useParams } from "react-router-dom";
import useRemoteSource from "./useRemoteSource";

export default function useRemotePull() {
  const source = useRemoteSource();
  const { pull: pullId } = useParams();

  if (source && pullId) {
    const filteredPulls = source.pulls.filter((pull) => pull.id === pullId);
    if (filteredPulls.length === 1) return filteredPulls[0];
  }

  return null;
}
